import React, { useEffect, useState } from 'react';

import type { RadioChangeEvent } from 'antd';

import { flightTripOptions } from '@components/views/flight/constants';
import { FlightTripType } from '@components/views/flight/types';
import { FlightSearchBarActionType } from '@domain/flight/context/flight/actions';

import { StyledRadio } from './styled';
import useFlightSearchBar from '../../context/flight';

const TripSelection = () => {
  const { state, dispatch } = useFlightSearchBar();

  const [tripType, setTripType] = useState<FlightTripType>('round-trip');

  useEffect(() => {
    setTripType(state?.isOneWay ? 'one-way' : 'round-trip');
  }, [state]);

  const handleChange = (event: RadioChangeEvent) => {
    const currentTripType = (event.target as HTMLInputElement)
      .value as FlightTripType;
    setTripType(currentTripType);
    dispatch({
      type: FlightSearchBarActionType.SET_IS_ONE_WAY,
      payload: currentTripType === 'one-way',
    });
  };

  return (
    <StyledRadio.Group
      onChange={handleChange}
      value={tripType}
      data-testid='flight-trip-selection'
    >
      {flightTripOptions.map((option) => (
        <StyledRadio key={option.value} value={option.value}>
          {option.label}
        </StyledRadio>
      ))}
    </StyledRadio.Group>
  );
};

export default TripSelection;
